<template>
  <div>
    <el-form ref="form" :model="form" class="form_flex">
      <el-form-item prop="status">
        <el-select
          class="search-select1"
          v-model="form.status"
          placeholder="请选择状态"
        >
          <el-option
            v-for="(item, index) in statusList"
            :key="index"
            :label="item"
            :value="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="customerName">
        <el-input
          class="search-input"
          v-model="form.customerName"
          placeholder="请输入客户名"
        ></el-input>
      </el-form-item>
      <el-form-item prop="userName">
        <el-select
          class="select"
          v-model="userName"
          filterable
          remote
          placeholder="请输入推荐人名字"
          :remote-method="searchUser"
          @change="checkItem"
          clearable
          :loading="loading"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="handleUserDecrypt(item.label, item.isShowAllPhone)"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item prop="dateTime">
        <el-date-picker
          v-model="dateTime"
          type="datetimerange"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="right"
          prop="dateTime"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item class="btn">
        <el-button @click="onSearch" icon="el-icon-search" size="small"
          >查询</el-button
        >
        <el-button size="small" icon="el-icon-plus" @click="resetForm('form')"
          >清空</el-button
        >
        <el-button size="small" @click="onRefresh" icon="el-icon-refresh"
          >刷新</el-button
        >
        <!-- <el-button size="small" icon="el-icon-plus" @click="onAdd" type="success" >新增</el-button> -->
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getUserModelApi } from '@/api/user.js';
import { decrypt } from '@/utils/encryp';
export default {
  name: 'UserSearchBar',
  // 与 layout 组件配合使用 provide / inject组合
  inject: ['reload'], // 注入reload方法
  data() {
    return {
      // 表单内容
      form: {
        customerName: '',
        status: '',
        startTime: '',
        endTime: '',
        userId: '',
      },
      userName: '',
      dateTime: '',
      options: [],
      loading: false,
    };
  },
  computed: {
    ...mapGetters(['statusList', 'pickerOptions']),
  },
  watch: {
    // 将标准时间转换成 yyyy-mm-dd
    dateTime: function (val) {
      let timeList = val.map((item) => {
        return this.$moment(item).format('YYYY-MM-DD HH:mm:ss');
      });
      this.form.startTime = timeList[0];
      this.form.endTime = timeList[1];
      return;
    },
  },
  methods: {
    // 搜索用户
    async searchUser(val) {
      this.loading = true;
      const areaId = localStorage.getItem('areaId')
        ? JSON.parse(localStorage.getItem('areaId')).areaId
        : '';
      let res = await getUserModelApi({ userName: val, areaId });
      this.loading = false;
      this.options = JSON.parse(
        JSON.stringify(res.data.dataList)
          .replace(/nickName/g, 'label')
          .replace(/userId/g, 'value')
      );
    },
    handleUserDecrypt(str, isShowAll) {
      if (!str) return;
      let index1 = str.indexOf('(');
      let index2 = str.indexOf(')');
      let str2 = str.substring(index1 + 1, index2);
      let str1 = str.replace(`(${str2})`, '');
      return `${decrypt(str1)}(${
        isShowAll
          ? decrypt(str2)
          : decrypt(str2).replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
      })`;
    },
    // 选择下拉选项
    checkItem(val) {
      this.form.userId = val;
    },

    // 搜索，触发父组件请求数据的方法
    onSearch() {
      // 0 = 全部， 没有0这个状态，重置为0
      if (this.form.status === 0) {
        this.form.status = '';
      }
      this.$emit('search', this.form);
    },

    // 刷新当前页面
    onRefresh() {
      this.reload();
    },

    // 清空表单
    resetForm(formName) {
      this.dateTime = '';
      this.userName = '';
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style lang="less" scoped>
.form_flex {
  display: flex;
}

.search-input {
  margin: 0 10px;
  width: 170px;
}

.search-select1 {
  width: 120px;
}

.select {
  margin-right: 10px;
}

button {
  height: 40px;
  margin-left: 10px;
}

/deep/ .el-form-item__content {
  display: flex;
}
</style>
